import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const weeks = [{
  title: 'SEMANA 1 – ENFOQUE',
  subtitle: 'Desintoxicación Mental',
  content: [{
    title: 'Mentoría 1: Diagnóstico brutal',
    items: ['Auditoría de hábitos', 'Identificación de excusas', 'Test de disciplina']
  }, {
    title: 'Mentoría 2: Protocolo de limpieza',
    items: ['Eliminación de distracciones', 'Regla de ejecución inmediata', 'Diseño de entorno']
  }]
}, {
  title: 'SEMANA 2 – FORTALEZA',
  subtitle: 'Construcción de Carácter',
  content: [{
    title: 'Mentoría 3: Identidad disciplinada',
    items: ['Dejar de depender de emociones', 'Construir auto-respeto', 'Dominio del diálogo interno']
  }, {
    title: 'Mentoría 4: Sistema de micro-victorias',
    items: ['Cómo crear consistencia', 'Método 1% diario', 'Construcción de palabra firme']
  }]
}, {
  title: 'SEMANA 3 – FRICCIÓN',
  subtitle: 'Exposición y Control',
  content: [{
    title: 'Mentoría 5: Control de impulsos',
    items: ['Finanzas y Redes', 'Placer inmediato', 'Decisiones emocionales']
  }, {
    title: 'Mentoría 6: Dominio bajo presión',
    items: ['Cómo actuar bajo estrés', 'Sostener disciplina cuando todo falla', 'Técnica de respiración']
  }]
}, {
  title: 'SEMANA 4 – FIRMEZA',
  subtitle: 'Identidad Permanente',
  content: [{
    title: 'Mentoría 7: Mentalidad largo plazo',
    items: ['Pensar en años, no días', 'Construcción de visión firme', 'Dejar de buscar validación']
  }, {
    title: 'Mentoría 8: Código personal',
    items: ['Reglamento interno', 'Sistema de revisión', 'Plan de mantenimiento 90 días']
  }]
}];
export function ProgramSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="programa" className="py-24 bg-[#0a0a0a]" data-id="element-320">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-321">
        <div className="text-center mb-16" data-id="element-322">
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white mb-2" data-id="element-323">
            PROGRAMA – DOMINIO MENTAL 30D
          </h2>
          <p className="text-gray-400" data-id="element-324">4 Semanas de Transformación Total</p>
        </div>

        <div className="space-y-4" data-id="element-325">
          {weeks.map((week, i) => <div key={i} className="border border-white/10 rounded-sm overflow-hidden bg-[#111]" data-id="element-326">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-327">
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-328">
                  <span className="text-[#C9A84C] font-['Bebas_Neue'] text-2xl" data-id="element-329">
                    0{i + 1}
                  </span>
                  <div data-id="element-330">
                    <h3 className="text-xl font-bold text-white" data-id="element-331">
                      {week.title}
                    </h3>
                    <p className="text-sm text-gray-400" data-id="element-332">{week.subtitle}</p>
                  </div>
                </div>
                <ChevronDown className={`text-[#C9A84C] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-333" />
              </button>

              <AnimatePresence data-id="element-334">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-335">
                    <div className="p-6 pt-0 border-t border-white/5" data-id="element-336">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6" data-id="element-337">
                        {week.content.map((mentoria, idx) => <div key={idx} className="space-y-3" data-id="element-338">
                            <h4 className="text-[#C9A84C] font-medium" data-id="element-339">
                              {mentoria.title}
                            </h4>
                            <ul className="space-y-2" data-id="element-340">
                              {mentoria.items.map((item, itemIdx) => <li key={itemIdx} className="text-sm text-gray-400 flex items-start gap-2" data-id="element-341">
                                  <span className="w-1 h-1 bg-gray-600 rounded-full mt-2 flex-shrink-0" data-id="element-342" />
                                  {item}
                                </li>)}
                            </ul>
                          </div>)}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}